var state = {
  loginModalVisible: false
};
var getters = {
  loginModalVisible: function loginModalVisible(state) {
    return state.loginModalVisible;
  }
};
var actions = {
  setShopLoginModalVisible: function setShopLoginModalVisible(_ref, visible) {
    var dispatch = _ref.dispatch,
        commit = _ref.commit,
        state = _ref.state;
    commit('SET_LOGIN_MODAL_VISIBLE', visible);
  }
};
var mutations = {
  SET_LOGIN_MODAL_VISIBLE: function SET_LOGIN_MODAL_VISIBLE(state, visible) {
    state.loginModalVisible = visible;
  }
};
export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};